export enum UserAccountTypeEnum {
  Member = 'member',
  User = 'user',
}
